import React from 'react';
import PropTypes from 'prop-types';
import dynamic from "next/dynamic";
import toKebabCase from "@gcloud-npm/utils.common.to-kebap-case";
import normalizeString from "@gcloud-npm/utils.metrics.normalize-string";
import styled from 'styled-components';
import Text, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_DISPLAY,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_SIZE,
} from "@/bit/components/components.text";
import Button, {
  BUTTON_OPERATION,
  BUTTON_WIDTH,
} from "@/bit/components/components.button";
import CustomLink from "@/bit/components/components.custom-link";
import Icon from "@/bit/components/components.icon-glyph";
import CmsFormField from "@/bit/components/components.cms-block.cms-form.cms-form-field";
const CmsAddElement = dynamic(() => import("@/bit/components/components.cms-block.cms-add-element"));

const CmsEditableGroupIcons = dynamic(
  () => import("@/bit/components/components.cms-block.cms-editable-group-icons")
);


const ID_TEMPLATE_ORION = {
  FIELD: '1776246',
  ENLACE: '1782430'
};

const CmsFormPage = styled.div`
  padding-top: 1rem;
  position: relative;
  .wrapper-title {
    display: flex;
    align-items: center;
    gap: 1.25rem;
  }
  .title-wrapper-text{
    max-width: fit-content;
    padding: 0.5rem 0;
    flex: 1;
  }
  .subtitle-wrapper {
    padding: 0.5rem 0;
  }
  .wrapper-questions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .wrapper--question-add {
    width: 100%;
  }
  .wrapper--question {
    padding: 0.5rem;
    box-sizing: border-box;
  }
  .wrapper-customLinks {
    position: relative;
    padding: 0.5em 0;
  }
  .wrapper-button {
    position: relative;
    text-align: ${props => props.formAlign? props.formAlign : 'center'};
    padding: 1rem 0rem;
    .button--fixed {
      position: relative;
    }
  }
  .wrapper-conditions {
    position: relative;
  }
  @media (max-width: 768px) {
    .wrapper-questions {
      flex-direction: column;
    }
    .wrapper--question {
      width: 100% !important;
      flex: 1 1 100% !important;
    }
    .wrapper-button {
    text-align: center;
    }
  }
`;

const CmsFormPages = (props) => {
  const { cmsHandler, blockName, alias, parentLocation, isResult, index, frontalListToDelete } = props;

    const addElementCmp = (index = "start", component, componentName, id) =>
    cmsHandler && (
      <div style={{width: '100%'}}>
        <CmsAddElement
          addProps={{
            index,
            idTemplateOrion: id,
            itemIdDotNotation: `${blockName}.${parentLocation}.${props.index}.${component}`,
            alias,
            layout: 'vertical',
            label: `Añadir ${componentName}`
          }}
          cmsHandler={cmsHandler}
        />
      </div>
    );

    return (<CmsFormPage formAlign={props.formAlign}>
      <CmsEditableGroupIcons
          elementProps={{
            ...props,
            editName: "cms-block.cms-form.cms-form-page",
          }}
          deleteProps={!isResult && {
            index,
            itemIdDotNotation: `${blockName}.${parentLocation}`,
            alias,
            frontalListToDelete
          }}
          visibleTools={{
            hiring: false,
            edit: true,
            deleteItem: true,
          }}
          cmsHandler={cmsHandler}
        />
      <div className="wrapper-title" style={{justifyContent: props['cms-atom-text-1'] && props['cms-atom-text-1'].align}}>
        {props['cms-atom-icon-1'] && (<Icon cmsHandler={cmsHandler} {...props['cms-atom-icon-1']}/>)}
        {(props['cms-atom-text-1']?.text || cmsHandler) && <div className="title-wrapper-text"><Text cmsHandler={cmsHandler} {...props['cms-atom-text-1']} /></div>}
      </div>
      {(props['cms-atom-text-2']?.text || cmsHandler) && <div className="subtitle-wrapper"><Text cmsHandler={cmsHandler} {...props['cms-atom-text-2']} /></div>}
      <div className="wrapper-questions">
        {!isResult && addElementCmp('start', 'cms-ml-question-list-1', 'Campo', ID_TEMPLATE_ORION.FIELD)}
        {props['cms-ml-question-list-1'] && props['cms-ml-question-list-1'].map((element, index) => (
            <CmsFormField parentLocation={`${parentLocation}.${props.index}`} index={index} frontalListToDelete={props['cms-ml-question-list-1']} cmsHandler={cmsHandler} blockName={blockName} alias={alias} handleField={props.handleField} {...element} value={props.data[element.nameId]?.value} name={element.nameId} error={props.data[element.nameId]?.error} />
        ))}
        {!isResult && props['cms-ml-question-list-1'] && props['cms-ml-question-list-1'].length > 0  && addElementCmp('end', 'cms-ml-question-list-1', 'Campo', ID_TEMPLATE_ORION.FIELD)}
      </div>
      <div className="wrapper-links">
        {addElementCmp('start', 'cms-ml-link-list-1', 'Enlace', ID_TEMPLATE_ORION.ENLACE)}
        {props['cms-ml-link-list-1'] && props['cms-ml-link-list-1'].map((element, index) => (
          <div className="wrapper-customLinks">
            <CmsEditableGroupIcons
              elementProps={{
                ...props,
                editName: "cms-block.cms-form.cms-form-page",
              }}
              deleteProps={!isResult && {
                index,
                itemIdDotNotation: `${blockName}.${parentLocation}.${props.index}.cms-ml-link-list-1`,
                alias,
                frontalListToDelete: props['cms-ml-link-list-1']
              }}
              visibleTools={{
                hiring: false,
                edit: false,
                deleteItem: true,
              }}
              cmsHandler={cmsHandler}
            />
          <CustomLink
            cmsHandler={cmsHandler}
            {...element['cms-atom-link-1']}
            taggingInfo={{
              ...props.taggingInfo,
              componentContent: element['cms-atom-text-1'].text,
            }}
          >
            <Text cmsHandler={cmsHandler} {...element['cms-atom-text-1']} />
          </CustomLink>
        </div>
        ))}
        {props['cms-ml-link-list-1'] && props['cms-ml-link-list-1'].length > 0 && addElementCmp('end', 'cms-ml-link-list-1', 'Enlace', ID_TEMPLATE_ORION.ENLACE)}
      </div>
      
      {props.send && props.pageIncorrects.length > 0 && (
        <>
        <Text
          cmsHandler={cmsHandler}
          text="Hubo un error, puedes verlo en estas paginas: "
          size={TEXT_SIZE.CAPTION}
          align={TEXT_ALIGN.LEFT}
          display={TEXT_DISPLAY.INLINE}
          kind={TEXT_KIND.SPAN}
          color={TEXT_COLOR.RED}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />
        {props.pageIncorrects.map((element, index) => {
          return <CustomLink
                cmsHandler={cmsHandler}
                title={`Volver a pagina ${element-label}`}
                onClick={() => {window.location.href = `#${normalizeString(toKebabCase(element.label))}`}}
                taggingInfo={{
                  ...props.taggingInfo,
                  componentContent: `back-to-${normalizeString(toKebabCase(element.label))}`,
                }}
                style={{ display: "contents" }}
              >
                <Text
                  cmsHandler={cmsHandler}
                  text={`${index == props.pageIncorrects.length - 1 && index != 0 ? ' y ' : index != 0 ? ', ': ''}${element.label}`}
                  size={TEXT_SIZE.CAPTION}
                  align={TEXT_ALIGN.LEFT}
                  display={TEXT_DISPLAY.INLINE}
                  kind={TEXT_KIND.SPAN}
                  color={TEXT_COLOR.RED}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
              </CustomLink>
          })}
        </>
      )}
      {props['cms-atom-button-1'] && (
        <div className="wrapper-button">
          <Button
            cmsHandler={cmsHandler}
            className={cmsHandler ? 'button--fixed' : ''}
            {...props['cms-atom-button-1']}
            disabled={!props.recaptchaReady}
            operation={
              props.waiting ? BUTTON_OPERATION.LOADING : BUTTON_OPERATION.NO
            }
            buttonTypeHtml={props['cms-atom-button-1'] && props['cms-atom-button-1'].href ? "" : "submit"}
            taggingInfo={{
              ...props.taggingInfo,
              componentContent: props['cms-atom-button-1']?.label ,
            }}
          />
        </div>
      )}
    </CmsFormPage>);
};

CmsFormPages.propTypes = {
  /**
   * {
   *  "info": "Nombre de la pagina, se usa para el stepper",
   *  "kind": "both",
   *  "beautifulName": "Nombre pagina"
   * }
   */
  namePage: PropTypes.string,
  /**
   * {
   *  "info": "Indica si es pagina de ok o ko",
   *  "kind": "dev",
   *  "beautifulName": "Pagina de resultado"
   * }
   */
  isResult: PropTypes.bool,
  /**
   * {
   *  "info": "Información si es la pagina final, se utiliza para mostrar los errores de otra pagina si procede",
   *  "kind": "dev",
   *  "beautifulName": "Pagina final"
   * }
   */
  send: PropTypes.bool,
  /**
   * {
   *  "info": "Almacena las paginas que contienen errores, para su pintado en la ultima fase",
   *  "kind": "dev",
   *  "beautifulName": "Paginas erroneas"
   * }
   */
  pageIncorrects: PropTypes.shape({
    label: PropTypes.string
  }),
  /**
   * {
   *  "info": "Indica si el recaptcha ya se cargo en pagina",
   *  "kind": "dev",
   *  "beautifulName": "Recaptcha listo"
   * }
   */
  recaptchaReady: PropTypes.bool,
  /**
   * {
   *  "info": "Indica si se esta esperando la respuesta del API",
   *  "kind": "dev",
   *  "beautifulName": "En espera"
   * }
   */
  waiting: PropTypes.bool,
  /**
   * {
   *  "info": "Información para el tagueado del componente.",
   *  "kind": "both",
   *  "beautifulName": "Información de tagueado"
   * }
   */
  taggingInfo: PropTypes.object,
  /**
   * {
   *  "info": "Información de los campos a mostrar",
   *  "kind": "dev",
   *  "beautifulName": "campos"
   * }
   */
  fields: PropTypes.object,
  /**
   * {
   *  "info": "Información de los valores de los campos y su estado",
   *  "kind": "dev",
   *  "beautifulName": "Datos"
   * }
   */
  data: PropTypes.object,
  /**
   * {
   *  "info": "Objecto que contiene las funciones para gestionar el guardado de los resultados de los campos",
   *  "kind": "dev",
   *  "beautifulName": "Handle de escritura"
   * }
   */
  handleField: PropTypes.shape({
    handleInput: PropTypes.func,
    handleSelect: PropTypes.func
  }),
};

export default CmsFormPages;
